module.exports = __webpack_public_path__ + "static/media/Robert LeDone.a2ac3ba9.png";